import { Autocomplete } from "components";
import React, { useEffect, useState } from "react";
import RelationshipServices from "services/RelationshipServices";
import CaseCloseServices from "services/CaseCloseServices";
/**
 * AutocompleteField - Themed, reusable autocomplete component with validation, using TextValidator as input.
 *
 * @param {object} props
 * @param {string} props.name - Name of the field (for form handling).
 * @param {string} [props.label] - Label for the field.
 * @param {any} props.value - Value (controlled, can be string, object, or array for multiple).
 * @param {function} props.onChange - Change handler (event, value) => void.
 * @param {boolean} [props.required] - Required field.
 * @param {Array} [props.validators] - Validation rules.
 * @param {Array} [props.errorMessages] - Validation error messages.
 * @returns {JSX.Element}
 */

const ForwardReasonDropDown = ({
    name,
    label,
    value,
    onChange,
    required = false,
    validators = [],
    errorMessages = [],
    ...rest
}) => {
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({
        limit: 50,
        page: 0,
        search: null,
        status: "Active",
        type: "FORWARD",
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [data] = await Promise.all([
                    CaseCloseServices.getAll({ ...filters }),
                ]);

                setData(data?.data?.view?.data || []);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [filters]);

    return (
        <div>
            <Autocomplete
                name={name}
                label={label}
                value={
                    (Array.isArray(value)
                        ? data.filter((item) => value.includes(item.id))
                        : data.find((item) => item.id === value)) || null
                } // Ensure value is an array of selected options
                onChange={(event, newValue) => {
                    if (onChange) onChange(event, newValue);
                }}
                options={data}
                getOptionLabel={(option) => option.reason || option.reason || ""}
                textInputOnChange={(e) => {
                    setFilters({ ...filters, search: e.target.value });
                }}
                //isOptionEqualToValue={(option, value) => option?.id === value?.id || option?.value === value?.value}
                required={required}
                validators={validators}
                errorMessages={errorMessages}
                TextFieldProps={{
                    placeholder: "Select reason",
                }}
                {...rest}
            />
        </div>
    );
};

export default ForwardReasonDropDown;
